'use strict';

const footer = document.querySelector('.footer');
const modals = document.querySelectorAll('.modal');
const triggers = document.querySelectorAll('.footer__link-service, [data-toggle="modal"][data-target]');
const closeBtns = document.querySelectorAll('.modal__close');

// const triggersLanding = document.querySelectorAll('.modal-trigger');

function closeModal(evt) {
  let modal = findModal(evt);
  let close_btn = evt.target.classList.contains("modal__close") ? this : evt.target.querySelector('.modal__close');

  if (!modal) modal = modals[index];
  if (!close_btn) close_btn = closeBtns[index];

  function hideModal(evt) {
    modal.style.display = 'none';
    modal.removeEventListener('animationend', hideModal);
  }

  modal.classList.remove('modal-open');
  modal.classList.add('modal-close');
  modal.addEventListener('animationend', hideModal);
  if (close_btn) { close_btn.removeEventListener('click', closeModal); }
}

function closeModalEasy(evt) {
  const modal = evt.target;

  if (evt.target.classList.contains('modal')) {
    closeModal(evt);
    modal.removeEventListener('click', closeModalEasy);
  }
}

function openModal(evt) {
  let modal = evt.target._mdl;
  let close_btn = modal.querySelector('.modal__close');

  if (!modal) modal = modals[index];
  if (!close_btn) close_btn = closeBtns[index];

  function replaceImageSources(modal) {
    const images = modal.querySelectorAll('img[data-src]');
    images.forEach(image => {
      image.setAttribute('src', image.getAttribute('data-src'));
      image.removeAttribute('data-src');
    })
  }

  evt.preventDefault();
  replaceImageSources(modal);
  modal.classList.remove('modal-close');
  modal.style.display = 'block';
  modal.classList.add('modal-open');
  if (close_btn) { close_btn.addEventListener('click', closeModal) };
  modal.addEventListener('click', closeModalEasy);
}

function modalOperation(triggerSet) {
  triggerSet.forEach((item, index) => {
    // для совместимости со старой версией
    let modal = modals[index];

    // к триггеру должна быть привязана 'цель'
    let tgt = item.getAttribute('data-target');

    if (tgt) {
      modal = document.getElementById(tgt);
    }

    // привязать модаль к триггеру
    item._mdl = modal;

    item.addEventListener('click', openModal);
  });
}

modalOperation(triggers);

// if (triggersLanding) {
//   console.log(modals);
//   modalOperation(triggersLanding);
// }

export function enableModal(modalQuery) {
  openModal({ target: { _mdl: document.querySelector(modalQuery) }, preventDefault: () => true })
}
export function disableModal(modalQuery) {
  const $modal = $(modalQuery);
  $modal.css("display", "none");
  $modal.removeClass('modal-open');
  $modal.addClass('modal-close');
}

function findModal(evt) {
  return evt.target.classList.contains('modal') ? evt.target : findAncestor(evt.target, '.modal');
}

function findAncestor(el, sel) {
  while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
  return el;
}

/**
 * Закрывает все открытые модалки и выводит модалку с информацией
 * 
 * @param {string} message - инъекция в html
 */
export function showInfoModal(message) {
  const modal = `
            <div id="info-modal" class="modal">
              <div class="modal__wrapper">
                <button class="modal__close" type="button">
                  Закрыть окно
                </button>
                <div>${message}</div>
              </div>
            </div>
          `

  $('#info-modal').remove();
  document.body.append(...$.parseHTML(modal));
  disableModal('.modal.modal-open')
  enableModal('#info-modal')
}